import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IconButton, Badge, Button, useTheme, useMediaQuery } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LoginOutlined from "@mui/icons-material/LoginOutlined";
import logo from "../static/media/logo_menu.png";
import { AppContext } from "../context/AppContext";
import Search from "./Navbar/Search";
import NavbarMobile from "./Navbar/NavbarMobile";
import "./Navbar.css";

export default function Navbar() {
  const { cartItems, logoutUser } = useContext(AppContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const [accountOpen, setAccountOpen] = useState(false);
  const accountRef = useRef(null);

  const [localLogin, setLocalLogin] = useState(localStorage.getItem("is_logged_in") === "true");
  const [localSuper, setLocalSuper] = useState(localStorage.getItem("is_superuser") === "true");
  const [localAdmin, setLocalAdmin] = useState(localStorage.getItem("is_admin") === "true");
  const [localVendedor, setLocalVendedor] = useState(localStorage.getItem("is_vendedor") === "true");

  const isSystemUser = localSuper || localAdmin || localVendedor;
  const cartCount = cartItems.reduce((s, i) => s + i.quantity, 0);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const syncAuth = () => {
    setLocalLogin(localStorage.getItem("is_logged_in") === "true");
    setLocalSuper(localStorage.getItem("is_superuser") === "true");
    setLocalAdmin(localStorage.getItem("is_admin") === "true");
    setLocalVendedor(localStorage.getItem("is_vendedor") === "true");
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch {}

    localStorage.removeItem("user_email");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_vendedor");
    localStorage.removeItem("is_logged_in");

    window.dispatchEvent(new Event("auth-change"));

    setAccountOpen(false);
    navigate("/", { replace: true });
  };

  const handleAccount = () => {
    setAccountOpen(false);
    if (isSystemUser) navigate("/admin-panel");
    else navigate("/user-panel");
  };

  const handleLogin = () => {
    setAccountOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    syncAuth();
    window.addEventListener("storage", syncAuth);
    window.addEventListener("auth-change", syncAuth);
    return () => {
      window.removeEventListener("storage", syncAuth);
      window.removeEventListener("auth-change", syncAuth);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="nav-wrap-h">
      <div className="nav-container-h">
        <div className="nav-row-h">
          <Link to="/" className="nav-logo-h">
            <img src={logo} alt="Hydroluz" />
          </Link>

          {!isMobile && (
            <div className="nav-search-h">
              <Search isMobile={false} />
            </div>
          )}

          <div className="nav-icons-h">
            {isMobile ? (
              <NavbarMobile
                cartCount={cartCount}
                showLogged={localLogin}
                isActive={isActive}
                navigate={navigate}
                onLogin={handleLogin}
                onLogout={handleLogout}
                onAccount={handleAccount}
              />
            ) : (
              <>
                <Link to="/shop" className="icon-link-h">
                  <Badge badgeContent={cartCount} color="error">
                    <ShoppingCartIcon />
                  </Badge>
                </Link>

                <div className="account-h" ref={accountRef}>
                  <IconButton className="icon-btn-h" onClick={() => setAccountOpen((v) => !v)}>
                    {localLogin ? <AccountCircleIcon /> : <LoginOutlined />}
                  </IconButton>

                  <div className={`account-dropdown-h ${accountOpen ? "open" : ""}`}>
                    {localLogin ? (
                      <>
                        <button onClick={handleAccount} className="dropdown-item-h">
                          Mi Cuenta
                        </button>
                        <button onClick={handleLogout} className="dropdown-item-h">
                          Cerrar Sesión
                        </button>
                      </>
                    ) : (
                      <button onClick={handleLogin} className="dropdown-item-h">
                        Iniciar Sesión
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {isMobile && (
          <div className="mobile-search-wrapper">
            <Search isMobile />
          </div>
        )}

        {!isMobile && (
          <nav className="nav-links-h">
            <Button className={`nav-btn-h ${isActive("/") ? "active" : ""}`} onClick={() => navigate("/")}>
              INICIO
            </Button>
            <Button className={`nav-btn-h ${isActive("/servicios") ? "active" : ""}`} onClick={() => navigate("/servicios")}>
              SERVICIOS
            </Button>
            <Button className={`nav-btn-h ${isActive("/club-hydroluz") ? "active" : ""}`} onClick={() => navigate("/club-hydroluz")}>
              CLUB HYDROLUZ
            </Button>
            <Button className={`nav-btn-h ${isActive("/categorias") ? "active" : ""}`} onClick={() => navigate("/categorias")}>
              TIENDA
            </Button>
            <Button className={`nav-btn-h ${isActive("/ofertas") ? "active" : ""}`} onClick={() => navigate("/ofertas")}>
              OFERTAS
            </Button>
            <Button className={`nav-btn-h ${isActive("/contactos") ? "active" : ""}`} onClick={() => navigate("/contactos")}>
              CONTACTOS
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
}
